import React from "react";
import {
  LABOR_OVERRIDE_CLEAR_HINT,
  NEGATIVE_LABOR_OVERRIDE_WARNING,
  ZERO_LABOR_BODY,
  ZERO_LABOR_CONFIRM_LABEL,
  ZERO_LABOR_HEADLINE,
  hasNegativeLaborOverride,
  hasZeroLaborOverride,
} from "./traceLabels";

/**
 * The resolved-warning control shared by a line and each child component.
 * Negative hours are invalid, while all-zero hours are owner-ratified only
 * after an estimator confirms them.
 */
function LaborOverrideAlert({ item, lineIndex, childIndex, dispatch }) {
  const actionTarget =
    childIndex === undefined
      ? { index: lineIndex }
      : { index: lineIndex, childIndex };
  const clearOverride = () =>
    dispatch({ type: "CLEAR_LINE_ITEM_LABOR_OVERRIDE", ...actionTarget });
  const confirmZeroLabor = () =>
    dispatch({ type: "CONFIRM_ZERO_LABOR_OVERRIDE", ...actionTarget });

  if (hasNegativeLaborOverride(item)) {
    return (
      <div className="est-override__zero" role="alert">
        <p className="est-override__zero-hd">
          {NEGATIVE_LABOR_OVERRIDE_WARNING}
        </p>
        <div className="est-override__zero-acts">
          <button
            type="button"
            className="wb-tbtn"
            onClick={clearOverride}
            title={LABOR_OVERRIDE_CLEAR_HINT}
          >
            Use the rate card instead
          </button>
        </div>
      </div>
    );
  }

  if (!hasZeroLaborOverride(item) || item?.zero_labor_confirmed) return null;

  return (
    <div className="est-override__zero" role="alert">
      <p className="est-override__zero-hd">{ZERO_LABOR_HEADLINE}</p>
      <p className="est-override__zero-copy">{ZERO_LABOR_BODY}</p>
      <div className="est-override__zero-acts">
        <button
          type="button"
          className="wb-tbtn wb-tbtn--edge est-override__zero-btn"
          onClick={confirmZeroLabor}
        >
          {ZERO_LABOR_CONFIRM_LABEL}
        </button>
        <button
          type="button"
          className="wb-tbtn"
          onClick={clearOverride}
          title={LABOR_OVERRIDE_CLEAR_HINT}
        >
          Use the rate card instead
        </button>
      </div>
    </div>
  );
}

export default LaborOverrideAlert;
